(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  // Prev/next + optional autoplay for the announcement bar's slides, with
  // a Motion-driven crossfade between them. Each .announcement-bar__carousel
  // on the page runs independently.
  document.querySelectorAll('[data-announcement-bar]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-announcement-slide]'));
    if (slides.length < 2) return;

    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Motion's usual `import { animate } from '...'` is a MODULE-level
    // statement — but Shopify's javascript-tag bundling produces a classic
    // (non-module) script, and a top-level `import` there throws a
    // SyntaxError that kills parsing for the WHOLE bundle, not just this
    // section. A dynamic import() is just a function call (valid anywhere)
    // that still loads Motion as a real ES module under the hood. Kicked
    // off here at module scope so the fetch is already in flight before
    // the first transition, same pattern as snippets/mobile-nav.liquid —
    // don't "simplify" this back to a static import, see AGENTS.md §
    // Mobile navigation for what that cost the last time. Skipped entirely
    // under prefers-reduced-motion, same as autoplay below.
    const motionPromise = prefersReducedMotion ? null : import('https://cdn.jsdelivr.net/npm/motion@11/+esm');

    function readDuration(cssVar, fallbackSeconds) {
      const raw = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
      if (raw.endsWith('ms')) return parseFloat(raw) / 1000;
      if (raw.endsWith('s')) return parseFloat(raw);
      return fallbackSeconds;
    }

    function readEasing(cssVar, fallback) {
      const raw = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
      const match = raw.match(/cubic-bezier\(([^)]+)\)/);
      if (!match) return fallback;
      const values = match[1].split(',').map((n) => parseFloat(n.trim()));
      return values.length === 4 ? values : fallback;
    }

    // Falls back to an instant class swap if Motion never loads (or
    // reduced motion is on) — a flaky CDN shouldn't leave a slide stuck
    // half-faded. Cleanup (removing .is-active from the outgoing slide,
    // clearing any inline opacity Motion left behind so .is-active's own
    // CSS fully governs the resting state again) runs off a plain
    // setTimeout matched to the animation's own `duration`, NOT by
    // awaiting Motion's `animate(...).finished` promise — that promise
    // was found to hang indefinitely in testing (reproduced in isolation:
    // a bare `animate(el, {opacity:[0,1]}, {duration:0.2}).finished` never
    // settled), which left every slide stuck with `.is-active` piled up
    // simultaneously since cleanup never ran. `setTimeout` doesn't depend
    // on Motion's completion signal at all, so it can't hang the same way.
    // Same risk likely applies to `snippets/mobile-nav.liquid`'s own
    // `.finished` await — flagged separately, out of scope for this file.
    function crossfade(outgoing, incoming) {
      incoming.classList.add('is-active');
      incoming.setAttribute('aria-hidden', 'false');
      outgoing.setAttribute('aria-hidden', 'true');

      function cleanup() {
        outgoing.classList.remove('is-active');
        outgoing.style.opacity = '';
        incoming.style.opacity = '';
      }

      if (!motionPromise) {
        cleanup();
        return;
      }

      const duration = readDuration('--dur-base', 0.2);
      const easing = readEasing('--ease-standard', 'ease-out');

      motionPromise
        .then(({ animate }) => {
          animate(outgoing, { opacity: [1, 0] }, { duration, easing });
          animate(incoming, { opacity: [0, 1] }, { duration, easing });
        })
        .catch(() => {
          // Ignore — cleanup below still runs on schedule either way.
        });

      setTimeout(cleanup, duration * 1000);
    }

    function showSlide(index) {
      const outgoing = slides[activeIndex];
      activeIndex = (index + slides.length) % slides.length;
      const incoming = slides[activeIndex];
      if (incoming === outgoing) return;
      crossfade(outgoing, incoming);
    }

    const autoplaySpeed = Number(carousel.dataset.autoplaySpeed);
    let timer = null;

    function stopTimer() {
      clearInterval(timer);
      timer = null;
    }

    // Called on mount and after every manual prev/next click, restarting
    // the interval from zero rather than letting the existing one keep
    // counting down — without this, clicking next right before the timer
    // was due to fire anyway immediately double-advances the slide, which
    // reads as broken/twitchy.
    function restartTimer() {
      stopTimer();
      if (autoplaySpeed && !prefersReducedMotion) {
        timer = setInterval(() => showSlide(activeIndex + 1), autoplaySpeed);
      }
    }

    carousel.querySelector('[data-announcement-prev]')?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      restartTimer();
    });

    carousel.querySelector('[data-announcement-next]')?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      restartTimer();
    });

    restartTimer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  // Two-panel resize slider — see this file's top comment for the full
  // "fixed content layer behind a resizing window" mechanic. NOT part of
  // assets/carousel.js's <theme-carousel> (resizing a before/after split
  // isn't a scrolling concern), and drives the drag via Pointer Events
  // rather than the mouse-only listener trio <theme-carousel>'s own
  // drag-to-scroll uses.
  class BeforeAfterSlider extends HTMLElement {
    connectedCallback() {
      this._row = this.querySelector('[data-baf-row]');
      this._handle = this.querySelector('[data-baf-handle]');
      this._contents = Array.prototype.slice.call(this.querySelectorAll('[data-baf-content]'));
      this._card = this.querySelector('[data-baf-card]');
      if (!this._row || !this._handle || !this._contents.length) return;

      const initial = parseFloat(this.dataset.bafInitial);
      this._initialSplit = Math.max(20, Math.min(80, isNaN(initial) ? 50 : initial));

      this._onPointerDown = this._onPointerDown.bind(this);
      this._onPointerMove = this._onPointerMove.bind(this);
      this._onPointerUp = this._onPointerUp.bind(this);
      this._onKeyDown = this._onKeyDown.bind(this);
      this._measure = this._measure.bind(this);

      this._handle.addEventListener('pointerdown', this._onPointerDown);
      this._handle.addEventListener('keydown', this._onKeyDown);

      // Re-measure the row's own width (and, off that, the card's fixed
      // width — see _measure() below) on a real resize/breakpoint change
      // only — NEVER during a drag (see _setSplit()/_measure() for why
      // that distinction is the whole point of this element). A plain
      // 'resize' listener already covers every case this needs.
      window.addEventListener('resize', this._measure);

      this._measure();
      this._setSplit(this._initialSplit);
    }

    disconnectedCallback() {
      this._handle.removeEventListener('pointerdown', this._onPointerDown);
      this._handle.removeEventListener('keydown', this._onKeyDown);
      window.removeEventListener('resize', this._measure);
    }

    // Sets each .before-after__content layer's width to the ROW's own
    // width — NOT the panel's, which is what actually stops the photo/
    // label from resizing as the panel's grid track changes. Also sizes
    // the After card off a separate, narrower measurement than that
    // full-row content layer: the After panel's OWN rendered width at the
    // section's starting (`initial_split`) position, deliberately based
    // on the INITIAL split percentage, not whatever position the handle
    // currently happens to be dragged to (`_setSplit()` never touches
    // this). Grid `fr` tracks split the row's width AFTER subtracting the
    // gap, in proportion to the two fr values (which always sum to 100
    // here) — reproducing that math directly is simpler and exact, vs.
    // reading the After panel element's own rect (which would report
    // whatever the CURRENTLY dragged split is, not the starting one,
    // since panel and content share the same DOM regardless of drag
    // position). Called once at connect and again only on a real window
    // resize; a drag frame never touches this.
    _measure() {
      const rect = this._row.getBoundingClientRect();
      if (!rect.width) return;
      this._contents.forEach((content) => {
        content.style.width = `${rect.width}px`;
      });

      if (this._card) {
        const gap = parseFloat(getComputedStyle(this._row).columnGap) || 0;
        const availableWidth = rect.width - gap;
        const afterWidthAtInitialSplit = (availableWidth * (100 - this._initialSplit)) / 100;
        // Desktop frame (node 38:961) pins the card to a fixed 319px
        // regardless of panel size — capped to the panel's own starting
        // width so it never outgrows a heavily skewed initial_split (e.g.
        // `initial_split: 20`, where the After panel starts far narrower
        // than 319px). Mobile frame (node 40:1851) instead has the card
        // fill that starting width edge-to-edge, uncapped — matching its
        // own `width: 100%` in the design.
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const cardWidth = isMobile ? afterWidthAtInitialSplit - 16 : Math.min(319, afterWidthAtInitialSplit);
        this._card.style.width = `${cardWidth}px`;
      }
    }

    // Clamped to the same 20–80 range as this section's `initial_split`
    // setting — a panel (and the After card living inside it) collapsed
    // much past that reads as broken rather than "revealed."
    _setSplit(percent) {
      const clamped = Math.max(20, Math.min(80, percent));
      this._row.style.setProperty('--baf-track-before', `${clamped}fr`);
      this._row.style.setProperty('--baf-track-after', `${100 - clamped}fr`);
      this._handle.style.left = `${clamped}%`;
      this._handle.setAttribute('aria-valuenow', String(Math.round(clamped)));
    }

    _percentFromClientX(clientX) {
      const rect = this._row.getBoundingClientRect();
      if (!rect.width) return 50;
      return ((clientX - rect.left) / rect.width) * 100;
    }

    _onPointerDown(event) {
      // setPointerCapture routes every subsequent pointermove/pointerup for
      // this pointer straight to the handle regardless of where it travels
      // — the whole reason this doesn't need window-level listeners the
      // way assets/carousel.js's mouse-only drag does.
      this._handle.setPointerCapture(event.pointerId);
      this._handle.addEventListener('pointermove', this._onPointerMove);
      this._handle.addEventListener('pointerup', this._onPointerUp);
      this._setSplit(this._percentFromClientX(event.clientX));
    }

    _onPointerMove(event) {
      this._setSplit(this._percentFromClientX(event.clientX));
    }

    _onPointerUp(event) {
      this._handle.releasePointerCapture(event.pointerId);
      this._handle.removeEventListener('pointermove', this._onPointerMove);
      this._handle.removeEventListener('pointerup', this._onPointerUp);
    }

    _onKeyDown(event) {
      const current = parseFloat(this._handle.getAttribute('aria-valuenow')) || 50;
      if (event.key === 'ArrowLeft') {
        this._setSplit(current - 5);
      } else if (event.key === 'ArrowRight') {
        this._setSplit(current + 5);
      } else if (event.key === 'Home') {
        this._setSplit(20);
      } else if (event.key === 'End') {
        this._setSplit(80);
      } else {
        return;
      }
      event.preventDefault();
    }
  }

  customElements.define('before-after-slider', BeforeAfterSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    class CartPage extends HTMLElement {
      connectedCallback() {
        this.itemsList = this.querySelector('[data-cart-items]');
        this.emptyEl = this.querySelector('[data-cart-empty]');
        this.layoutEl = this.querySelector('[data-cart-layout]');
        this.subtotalEl = this.querySelector('[data-cart-subtotal]');
        this._busyKeys = new Set();
        this._cart = null;
        // See this file's doc comment on the <template data-cart-remove-icon>
        // above the <form> — the one source of truth for this glyph, so the
        // JS-rendered list below never drifts from the SSR list's icon.
        var removeIconTemplate = this.querySelector('[data-cart-remove-icon]');
        this._removeIconHtml = removeIconTemplate ? removeIconTemplate.innerHTML : '';

        // Translated aria-labels for the JS-rendered controls below — see
        // this file's own doc comment above the data-*-label attributes.
        this._labels = {
          decrease: this.dataset.decreaseLabel || '',
          increase: this.dataset.increaseLabel || '',
          remove: this.dataset.removeLabel || '',
          quantity: this.dataset.quantityLabel || '',
        };

        this.itemsList.addEventListener('click', this._onClick.bind(this));
        this.itemsList.addEventListener('change', this._onChange.bind(this));

        // No window.GoarCart — leave the server-rendered <form> above
        // exactly as-is, a plain fully-functional no-JS cart (see this
        // file's own doc comment). Nothing below this point should run.
        if (!window.GoarCart) return;

        document.addEventListener('cart:updated', this._onCartUpdated.bind(this));

        // Instant, no network wait — see assets/cart.js's seed comment:
        // getState() already reflects the server-rendered cart on load,
        // thanks to layout/theme.liquid's window.__CART__ seed.
        var seeded = window.GoarCart.getState();
        if (seeded) this._renderCart(seeded);
      }

      _onCartUpdated(event) {
        this._renderCart(event.detail.cart);
      }

      _onClick(event) {
        var line = event.target.closest('[data-cart-item]');
        if (!line) return;
        var key = line.dataset.lineKey;
        var input = line.querySelector('[data-qty-input]');

        if (event.target.closest('[data-qty-decrease]')) {
          this._updateItem(key, Math.max(0, Number(input.value) - 1));
        } else if (event.target.closest('[data-qty-increase]')) {
          this._updateItem(key, Number(input.value) + 1);
        } else if (event.target.closest('[data-cart-remove]')) {
          this._updateItem(key, 0);
        }
      }

      _onChange(event) {
        if (!event.target.matches('[data-qty-input]')) return;
        var line = event.target.closest('[data-cart-item]');
        var quantity = Math.max(0, Number(event.target.value) || 0);
        this._updateItem(line.dataset.lineKey, quantity);
      }

      _updateItem(key, quantity) {
        if (this._busyKeys.has(key)) return;
        this._busyKeys.add(key);
        if (this._cart) this._renderCart(this._cart);

        window.GoarCart.updateItem(key, quantity)
          .catch(function () {
            // GoarCart already dispatched 'cart:error' — the .finally()
            // below still clears the busy state, since a failed update
            // never fires 'cart:updated'.
          })
          .finally(
            function () {
              this._busyKeys.delete(key);
              if (this._cart) this._renderCart(this._cart);
            }.bind(this),
          );
      }

      _renderCart(cart) {
        this._cart = cart;

        var hasItems = cart.item_count > 0;
        this.emptyEl.hidden = hasItems;
        this.layoutEl.hidden = !hasItems;
        if (!hasItems) return;

        // NOTE: `cart.currency` in the `cart | json`/Cart AJAX API shape is
        // a plain ISO code STRING ("GBP") — unlike the server-side Liquid
        // `cart` drop, where `cart.currency` is an object with `.iso_code`.
        // Don't reach for `.iso_code` here, that's the Liquid-only shape.
        var currency = cart.currency;
        this.itemsList.innerHTML = cart.items.map(this._itemHtml.bind(this)).join('');
        this.subtotalEl.textContent = this._formatMoney(cart.total_price, currency);
      }

      _itemHtml(item) {
        var busy = this._busyKeys.has(item.key);
        var currency = this._cart && this._cart.currency;
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        var image = item.image ? this._resizedImage(item.image) : '';
        var esc = this._escape;
        var labels = this._labels;

        return [
          '<li class="cart-item' + (busy ? ' is-busy' : '') + '" data-cart-item data-line-key="' + esc(item.key) + '">',
          '<a href="' + esc(item.url) + '" class="cart-item__image" tabindex="-1" aria-hidden="true">',
          image
            ? '<img src="' + esc(image) + '" alt="' + esc(item.product_title) + '" width="80" height="80" loading="lazy">'
            : '',
          '</a>',
          '<div class="cart-item__details">',
          '<a href="' + esc(item.url) + '" class="cart-item__title">' + esc(item.product_title) + '</a>',
          variantTitle ? '<p class="cart-item__variant">' + esc(variantTitle) + '</p>' : '',
          this._propertiesHtml(item.properties, esc),
          '<p class="cart-item__price">' + this._formatMoney(item.final_price, currency) + '</p>',
          this._discountsHtml(item.line_level_discount_allocations, currency, esc),
          '</div>',
          '<div class="cart-item__qty" data-qty-wrap>',
          '<button type="button" class="cart-item__qty-btn" data-qty-decrease aria-label="' +
            esc(labels.decrease) +
            '"' +
            (busy ? ' disabled' : '') +
            '>−</button>',
          '<input type="number" class="cart-item__qty-input" value="' +
            esc(item.quantity) +
            '" min="0" inputmode="numeric" data-qty-input aria-label="' +
            esc(labels.quantity) +
            '"' +
            (busy ? ' disabled' : '') +
            '>',
          '<button type="button" class="cart-item__qty-btn" data-qty-increase aria-label="' +
            esc(labels.increase) +
            '"' +
            (busy ? ' disabled' : '') +
            '>+</button>',
          '</div>',
          '<p class="cart-item__total">' + this._formatMoney(item.final_line_price, currency) + '</p>',
          '<button type="button" class="cart-item__remove" data-cart-remove aria-label="' +
            esc(labels.remove) +
            '"' +
            (busy ? ' disabled' : '') +
            '>',
          this._removeIconHtml,
          '</button>',
          '</li>',
        ].join('');
      }

      // Mirrors blocks/cart-items.liquid's `item.properties` loop — hidden
      // properties (keys starting with `_`) are already excluded from the
      // Cart AJAX API's `item.properties`, same as the Liquid `item` drop.
      _propertiesHtml(properties, esc) {
        if (!properties) return '';
        var rows = Object.keys(properties)
          .filter(function (key) {
            return properties[key] != null && properties[key] !== '';
          })
          .map(function (key) {
            return (
              '<div class="cart-item__property"><dt>' +
              esc(key) +
              ':</dt><dd>' +
              esc(properties[key]) +
              '</dd></div>'
            );
          });
        if (!rows.length) return '';
        return '<dl class="cart-item__properties">' + rows.join('') + '</dl>';
      }

      // Mirrors blocks/cart-items.liquid's `item.line_level_discount_allocations`
      // loop — same field name/shape in both the Liquid `cart` drop and the
      // Cart AJAX API's JSON.
      _discountsHtml(discountAllocations, currency, esc) {
        if (!discountAllocations || !discountAllocations.length) return '';
        var self = this;
        var rows = discountAllocations.map(function (allocation) {
          return (
            '<li class="cart-item__discount">' +
            esc(allocation.discount_application.title) +
            ' (-' +
            self._formatMoney(allocation.amount, currency) +
            ')</li>'
          );
        });
        return '<ul class="cart-item__discounts">' + rows.join('') + '</ul>';
      }

      _resizedImage(src) {
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
      }

      _escape(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
        });
      }

      _formatMoney(cents, currency) {
        if (typeof cents !== 'number') return '';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency: currency || 'GBP',
          }).format(cents / 100);
        } catch (error) {
          return (cents / 100).toFixed(2);
        }
      }
    }

    if (!customElements.get('cart-page')) {
      customElements.define('cart-page', CartPage);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
  // Reveals the "Read more" toggle (and its fade) only when the description
  // is genuinely taller than its crop — see this file's top comment. Runs
  // once per instance; CSS (.is-expanded) does the actual expand/collapse.
  document.querySelectorAll('[data-description-collapse]').forEach((wrap) => {
    const content = wrap.querySelector('[data-description-content]');
    const toggle = wrap.querySelector('[data-description-toggle]');
    const label = wrap.querySelector('[data-description-toggle-label]');
    if (!content || !toggle || !label) return;

    if (content.scrollHeight <= content.clientHeight + 1) return;

    wrap.classList.add('has-overflow');
    toggle.hidden = false;

    const readMoreLabel = label.textContent;
    const readLessLabel = toggle.dataset.readLessLabel || readMoreLabel;

    toggle.addEventListener('click', () => {
      const expanded = wrap.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? readLessLabel : readMoreLabel;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // "Live updating" collection filters — fetches this section's own
  // rendered HTML via the Section Rendering API and swaps it in, instead of
  // a full page navigation. See this file's top comment for why. All
  // filtering/sorting/pagination logic stays server-side in Liquid; this
  // class only (1) serializes the current filter/sort form into a URL, (2)
  // fetches + swaps the section, (3) keeps the browser URL and this panel's
  // open/expanded UI state in sync across that swap.
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.form = this.querySelector('[data-filter-form]');
      this.toggle = this.querySelector('[data-filter-toggle]');

      // The "Filter" toggle is the only open/close control at either
      // breakpoint — no separate close button (see this file's top
      // comment).
      if (this.toggle) {
        this.toggle.addEventListener('click', () => this.togglePanel());
      }

      // Two sort controls exist in the DOM at all times (the toolbar
      // <select> and the mobile radio list), sharing name="sort_by" — keep
      // only the currently-visible one enabled so FormData never picks up
      // both. See this file's top comment.
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.mobileQueryHandler = () => this.syncSortControls();
      this.mobileQuery.addEventListener('change', this.mobileQueryHandler);
      this.syncSortControls();

      // Any checkbox/price input inside the filter panel (this now
      // includes the mobile sort radios — they live inside
      // [data-filter-panel] too), or the toolbar's sort select, triggers a
      // live update on change — no submit button, per Figma (the
      // checkboxes have none) and the "live updating" brief.
      this.form.addEventListener('change', (event) => {
        if (event.target.closest('[data-filter-panel]') || event.target.matches('[data-sort-select]')) {
          this.update();
        }
      });

      // Pagination links and "Clear all" both point at real, working URLs
      // (server-rendered, correct with JS off) — intercepted here only to
      // upgrade them to the same AJAX swap instead of a full reload.
      this.clickHandler = (event) => {
        const link = event.target.closest('.pagination a, .collection-filters__clear');
        if (!link) return;
        event.preventDefault();
        this.update(link.href);
      };
      this.addEventListener('click', this.clickHandler);

      this.popstateHandler = () => this.update(window.location.href, false);
      window.addEventListener('popstate', this.popstateHandler);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.popstateHandler);
      this.mobileQuery.removeEventListener('change', this.mobileQueryHandler);
    }

    // Keeps whichever sort control CSS is currently hiding disabled, so
    // FormData (see buildUrl()) only ever picks up the one the customer
    // can actually see/use. `disabled` — not just visually hiding one via
    // CSS — is what excludes a field from FormData; without this, a
    // hidden-but-still-enabled control would silently add a second
    // `sort_by` to the built URL alongside the visible one's value. Run
    // once up front (connectedCallback) and again on every breakpoint
    // crossing (the matchMedia listener there) — a window resize or
    // device rotation can flip which control is actually visible without
    // the page ever reloading.
    syncSortControls() {
      const isMobile = this.mobileQuery.matches;
      this.querySelectorAll('[data-sort-select]').forEach((select) => {
        select.disabled = isMobile;
      });
      this.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((radio) => {
        radio.disabled = !isMobile;
      });
    }

    // "Filter" shows/hides the WHOLE panel of accordions as one block
    // (animated via `.collection__filters-panel`'s own transition, both
    // breakpoints — see this file's top comment) — it does not touch any
    // individual accordion's own open/closed state. Each group still
    // defaults to only the first one open (snippets/collection-filters.
    // liquid's `open: forloop.first`) and the customer expands the rest
    // themselves, same as tapping "Filter" again just re-reveals whatever
    // state they were left in.
    togglePanel() {
      const isOpen = this.classList.toggle('is-filters-open');
      this.toggle.setAttribute('aria-expanded', String(isOpen));
    }

    // Builds a fresh query string from every named field currently in the
    // form (checked checkboxes, filled price inputs, the sort select).
    // Deliberately NOT merging with the current URL's existing query
    // string — the checked/filled form fields already fully describe the
    // desired filter state, and omitting a stale `page` param this way is
    // what resets pagination to page 1 on every filter/sort change.
    buildUrl() {
      const params = new URLSearchParams(new FormData(this.form));
      Array.from(params.keys()).forEach((key) => {
        if (params.get(key) === '') params.delete(key);
      });
      const query = params.toString();
      return `${window.location.pathname}${query ? '?' + query : ''}`;
    }

    async update(url, pushState = true) {
      const target = url || this.buildUrl();
      const sectionUrl = `${target}${target.includes('?') ? '&' : '?'}section_id=${this.sectionId}`;

      // The outerHTML swap below replaces this element outright (a fresh
      // <collection-filters> re-upgrades via connectedCallback), so any UI
      // state that should survive the swap has to be captured now and
      // reapplied to the NEW instance afterwards.
      const wasOpen = this.classList.contains('is-filters-open');
      const openGroups = Array.from(
        this.querySelectorAll('[data-accordion-toggle][aria-expanded="true"]')
      ).map((toggle) => toggle.getAttribute('aria-controls'));

      this.setAttribute('aria-busy', 'true');

      let html;
      try {
        const response = await fetch(sectionUrl);
        if (!response.ok) throw new Error(`Section request failed: ${response.status}`);
        html = await response.text();
      } catch (error) {
        this.removeAttribute('aria-busy');
        return;
      }

      const wrapper = document.getElementById(`shopify-section-${this.sectionId}`);
      if (!wrapper) return;
      wrapper.outerHTML = html;

      const fresh = document.getElementById(`shopify-section-${this.sectionId}`)?.querySelector('collection-filters');
      if (fresh) {
        if (wasOpen) {
          fresh.classList.add('is-filters-open');
          fresh.querySelector('[data-filter-toggle]')?.setAttribute('aria-expanded', 'true');
        }
        openGroups.forEach((id) => {
          fresh.querySelector(`[aria-controls="${id}"]`)?.setAttribute('aria-expanded', 'true');
        });
      }

      if (pushState) {
        window.history.pushState({ collectionFilters: true }, '', target);
      }
    }
  }

  customElements.define('collection-filters', CollectionFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  // Same toggle mechanism as snippets/accordion.liquid: JS only flips
  // aria-expanded, the CSS above does the actual expand/collapse.
  //
  // Deliberately its own `data-faq-toggle` attribute rather than
  // accordion.liquid's `data-accordion-toggle`: this section renders on
  // the same collection page as snippets/collection-filters.liquid, which
  // DOES use accordion.liquid (and its bundled script does a global,
  // unscoped `document.querySelectorAll('[data-accordion-toggle]')`).
  // Reusing that attribute here would let both that script AND this one
  // attach a click listener to the same FAQ buttons — each toggle flips
  // `aria-expanded` back the instant the other just flipped it, so
  // clicking would appear to do nothing.
  document.querySelectorAll('[data-faq-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Mobile accordion toggle for the footer's menu columns. Desktop ignores
  // this entirely — the toggle button is pointer-events:none there (see
  // the stylesheet block above), so this listener never fires above
  // 750px. No outside-click-to-close (unlike the header's dropdown/
  // flyout): an accordion row only affects its own panel, nothing floats
  // over other content, so there's nothing to close on an outside click.
  document.querySelectorAll('.site-footer__menu-toggle').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Tap-to-open / tap-off-to-close for the header's dropdown (level 2) and
  // flyout (level 3) submenus. Hover open/close needs no JS — see the CSS
  // comment above .site-header__dropdown. Basic, no design spec for this
  // interaction beyond the developer's brief — see AGENTS.md § Header.
  (() => {
    const OPEN_SELECTOR = '.site-header__menu-item.is-open, .site-header__dropdown-item.is-open';

    function closeItem(item) {
      item.classList.remove('is-open');
      const toggle = item.querySelector(':scope > .site-header__menu-toggle, :scope > .site-header__flyout-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function closeAll() {
      document.querySelectorAll(OPEN_SELECTOR).forEach(closeItem);
    }

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('.site-header__menu-toggle, .site-header__flyout-toggle');

      if (toggle) {
        const item = toggle.closest('li');
        const isOpen = item.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
        return;
      }

      document.querySelectorAll(OPEN_SELECTOR).forEach((item) => {
        if (!item.contains(event.target)) closeItem(item);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  })();

  // Sticky-on-scroll-up header — the whole header-GROUP (announcement bar +
  // header, see the CSS block above for why the group wrapper, not the
  // header section's own wrapper, is what gets these classes). One
  // module-scope IIFE, no framework, same pattern this repo already uses
  // for cart count etc. Works identically on mobile and desktop; the
  // drawer/search overlays lock document scroll while open (see
  // snippets/mobile-nav.liquid), so no scroll events fire — and therefore
  // no hide/show — while either is open.
  //
  // Fully configurable per section.settings on the header section itself
  // (read off the `.site-header` element's own data-* attributes — this
  // section can't render attributes onto layout/theme.liquid's
  // `#site-header-group` wrapper, only onto elements it actually controls,
  // see the header section's schema for the settings themselves):
  //   - sticky_enabled: sticky at all, or plain static-flow header-group.
  //   - sticky_behavior: 'reveal' (hide on scroll down / reveal on scroll
  //     up, the original behavior) or 'always' (permanently pinned, never
  //     hidden).
  //   - sticky_shadow: whether the "stuck" state gets a drop shadow.
  (() => {
    const headerEl = document.querySelector('.site-header');
    // `#site-header-group` (layout/theme.liquid) — a wrapper we render
    // ourselves, not one Shopify generates. `{% sections 'header-group' %}`
    // has no single element with a predictable id around the whole group
    // (each section in it renders as its own sibling `.shopify-section`
    // div), so `headerEl.closest('[id^="shopify-section-group-"]')` here
    // previously always came back null and this whole feature silently
    // never engaged — see the CSS block above for the full story.
    const group = document.getElementById('site-header-group');
    if (!headerEl || !group) return;

    const stickyEnabled = headerEl.dataset.stickyEnabled === 'true';
    if (!stickyEnabled) return;

    const stickyBehavior = headerEl.dataset.stickyBehavior || 'reveal';
    const stickyShadow = headerEl.dataset.stickyShadow === 'true';

    const STICKY_CLASS = 'site-header-group--sticky';
    const HIDE_CLASS = 'site-header-group--hidden';
    const STUCK_CLASS = 'site-header-group--stuck';
    const SHADOW_CLASS = 'site-header-group--shadow';

    group.classList.add(STICKY_CLASS);
    group.classList.toggle(SHADOW_CLASS, stickyShadow);

    function setGroupHeight() {
      group.style.setProperty('--sticky-group-height', `${group.offsetHeight}px`);
    }
    setGroupHeight();

    if (window.ResizeObserver) {
      new ResizeObserver(setGroupHeight).observe(group);
    } else {
      window.addEventListener('resize', setGroupHeight);
    }

    let lastY = window.scrollY;
    let ticking = false;

    function update() {
      // iOS Safari's rubber-band overscroll can report a negative scrollY —
      // clamp so that bounce never gets misread as a big upward scroll.
      const y = Math.max(window.scrollY, 0);
      const groupHeight = group.offsetHeight;

      if (stickyBehavior === 'always') {
        // Permanently pinned — never hidden, regardless of scroll direction.
        group.classList.remove(HIDE_CLASS);
      } else if (y <= groupHeight) {
        // Never hide it near the top of the page — nothing to reclaim yet,
        // and it avoids a flicker as the group transitions into "stuck".
        group.classList.remove(HIDE_CLASS);
      } else if (y > lastY) {
        group.classList.add(HIDE_CLASS);
      } else if (y < lastY) {
        group.classList.remove(HIDE_CLASS);
      }

      group.classList.toggle(STUCK_CLASS, y > groupHeight);

      lastY = y;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  })();

  // Cart item count — driven entirely by window.GoarCart's `cart:updated`
  // event (assets/cart.js), never a local fetch here. See AGENTS.md § Cart.
  // cart.js is loaded (and its first fetchCart() kicked off) in
  // layout/theme.liquid before this bundle runs, but the listener is added
  // regardless of timing since 'cart:updated' fires again on every future
  // mutation, not just once at load.
  document.addEventListener('cart:updated', (event) => {
    const count = event.detail.cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count > 0 ? count : '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
  // Tap-to-open / tap-off-to-close for the hotspot markers. Only one card
  // open at a time (opening one closes any other) — a developer call, not
  // a Figma spec, since cards are free-positioned and could otherwise
  // overlap. Same event-delegation shape as sections/header.liquid's
  // dropdown/flyout toggles — see that file's javascript-tag bundle for
  // the precedent this copies.
  class HotspotGallery extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this._onDocumentClick = this._onDocumentClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onResize = this._onResize.bind(this);

      this.addEventListener('click', this._onClick);
      document.addEventListener('click', this._onDocumentClick);
      document.addEventListener('keydown', this._onKeydown);
      window.addEventListener('resize', this._onResize);

      // A block can be marked "expanded by default" (the `expanded` block
      // setting, rendered server-side as an initial `.is-open` spot) — if
      // a merchant marks more than one, enforce the same single-open
      // invariant a click does (keep the first, close the rest), then
      // bound whichever stays open to the gallery box via the exact same
      // _positionCard() a click uses, so the default-open card never just
      // sits at its raw centered position while a clicked-open one gets
      // flipped/nudged to stay visible.
      const openSpots = this.querySelectorAll('.hotspots__spot.is-open');
      if (openSpots.length) {
        this._closeAll(openSpots[0]);
        this._positionInitialCard(openSpots[0]);
      }
    }

    // A user can only ever click a marker once the page has fully settled
    // (styles applied, web fonts swapped in) — a `.is-open` card rendered
    // server-side has no such guarantee: connectedCallback can fire while
    // a custom heading/body font is still loading, so the card's measured
    // rect at that instant undershoots its real post-swap size and the
    // resulting flip/shift ends up stale, leaving the card clipped by the
    // gallery edge instead of nudged inside it. Position immediately (so
    // there's no flash of an unpositioned card), then again once the page
    // `load` event and any web fonts have actually finished, reusing the
    // same _positionCard() logic a click uses rather than a second copy.
    _positionInitialCard(spot) {
      this._positionCard(spot);
      window.addEventListener('load', () => this._positionCard(spot), { once: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this._positionCard(spot));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('keydown', this._onKeydown);
      window.removeEventListener('resize', this._onResize);
    }

    _closeAll(except) {
      this.querySelectorAll('.hotspots__spot.is-open').forEach((spot) => {
        if (spot === except) return;
        spot.classList.remove('is-open');
        const toggle = spot.querySelector('.hotspots__marker');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    // Keeps an open card fully inside THIS gallery's own box (the photo
    // it's laid over), instead of spilling past its edge — no Figma spec
    // for this beyond "stay inside the photo it belongs to," a developer
    // call. Flips the card to whichever side (`.hotspots__spot--left`)
    // actually fits horizontally, then nudges it up/down — via the
    // `--hotspot-card-shift-y` custom property the stylesheet above reads
    // — just enough to clear the top/bottom edge too, rather than a
    // fixed-offset guess. Safe to call on an already-open OR a
    // still-closed card: the card is `visibility: hidden` while closed,
    // not `display: none`, so it stays in normal layout flow and its rect
    // is measurable either way.
    _positionCard(spot) {
      const card = spot.querySelector('.hotspots__card');
      if (!card) return;

      // Reset before measuring so a stale flip/shift from a previous open
      // (or a since-resized viewport) never leaks into this measurement.
      card.style.removeProperty('--hotspot-card-shift-y');

      const galleryRect = this.getBoundingClientRect();
      let cardRect = card.getBoundingClientRect();

      // 12px, not 0 — `cardRect` is the whole `.hotspots__card` box
      // (getBoundingClientRect covers the card's own padding and its
      // right-aligned `.hotspots__card-link` button same as any other
      // content), so the flip already accounts for that button's full
      // width; this is purely a bit of breathing room past it, the same
      // kind of buffer the vertical shift below has always used, so the
      // button doesn't end up sitting flush against the photo's edge.
      const EDGE_PADDING = 12;

      if (cardRect.right > galleryRect.right - EDGE_PADDING && !spot.classList.contains('hotspots__spot--left')) {
        spot.classList.add('hotspots__spot--left');
        cardRect = card.getBoundingClientRect();
      } else if (cardRect.left < galleryRect.left + EDGE_PADDING && spot.classList.contains('hotspots__spot--left')) {
        spot.classList.remove('hotspots__spot--left');
        cardRect = card.getBoundingClientRect();
      }

      let shift = 0;
      if (cardRect.top < galleryRect.top + EDGE_PADDING) {
        shift = galleryRect.top + EDGE_PADDING - cardRect.top;
      } else if (cardRect.bottom > galleryRect.bottom - EDGE_PADDING) {
        shift = galleryRect.bottom - EDGE_PADDING - cardRect.bottom;
      }
      if (shift) card.style.setProperty('--hotspot-card-shift-y', `${shift}px`);
    }

    _onClick(event) {
      const toggle = event.target.closest('.hotspots__marker');
      if (!toggle) return;
      const spot = toggle.closest('.hotspots__spot');
      if (!spot) return;

      const isOpen = spot.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      this._closeAll(isOpen ? spot : null);
      if (isOpen) this._positionCard(spot);
    }

    _onDocumentClick(event) {
      if (this.contains(event.target)) return;
      this._closeAll(null);
    }

    _onKeydown(event) {
      if (event.key === 'Escape') this._closeAll(null);
    }

    _onResize() {
      const openSpot = this.querySelector('.hotspots__spot.is-open');
      if (openSpot) this._positionCard(openSpot);
    }
  }

  customElements.define('hotspot-gallery', HotspotGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  // Fetches this section's own markup back from Shopify's Section Rendering
  // API via `data-url` (built above from `routes.product_recommendations_url`
  // + section_id/product_id/intent/limit) and swaps it in — see this file's
  // top comment for why the plain Liquid render alone can't show anything on
  // a normal page load. Bundled once by Shopify's javascript-tag mechanism
  // regardless of instance count, so no `customElements.get` guard needed
  // (same as sections/before-after.liquid's inline custom element).
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      // Already carrying real content — happens when this exact markup IS
      // the response to the fetch below (Shopify re-renders this same file,
      // `recommendations` populated, when hit through `routes.product_
      // recommendations_url`) and something re-upgrades the element. Fetch
      // once per empty instance, never re-fetch an already-populated one.
      if (this.querySelector('.product-recommendations')) return;

      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const content = doc.querySelector('product-recommendations');
          if (content && content.innerHTML.trim().length) {
  this.innerHTML = content.innerHTML;

  const variant = this.dataset.styleVariant || 'centered';
  const recommendations = this.querySelector('.product-recommendations');

  if (recommendations) {
    recommendations.classList.remove(
      'product-recommendations--centered',
      'product-recommendations--left'
    );

    recommendations.classList.add(
      `product-recommendations--${variant}`
    );
  }

  if (variant === 'left') {
    const headingPrefix = this.querySelector(
      '.product-recommendations__heading-prefix'
    );

    if (headingPrefix) {
      headingPrefix.classList.add('goar-display');
    }
  }
}
        })
        .catch(() => {
          // Network/parse failure — stay empty rather than show a broken
          // state, same silent-degrade philosophy as sections/related-
          // collections.liquid when its metafield is blank.
        });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // "Live updating" search product filters — same Section Rendering API
  // pattern as sections/collection.liquid's `<collection-filters>` (fetch
  // this section's own rendered HTML, swap the whole
  // `#shopify-section-{id}` wrapper, keep the URL/open-panel state in sync
  // across that swap). Kept as its own tag/class in this file rather than
  // reusing `<collection-filters>` — see this file's top comment for why.
  class SearchFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.form = this.querySelector('[data-filter-form]');
      this.toggle = this.querySelector('[data-filter-toggle]');

      if (this.toggle) {
        this.toggle.addEventListener('click', () => this.togglePanel());
      }

      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.mobileQueryHandler = () => this.syncSortControls();
      this.mobileQuery.addEventListener('change', this.mobileQueryHandler);
      this.syncSortControls();

      this.form.addEventListener('change', (event) => {
        if (event.target.closest('[data-filter-panel]') || event.target.matches('[data-sort-select]')) {
          this.update();
        }
      });

      // Pagination links and "Clear all" both point at real, working URLs
      // (server-rendered, correct with JS off) — intercepted here only to
      // upgrade them to the same AJAX swap instead of a full reload. Scoped
      // to `this` (the <search-filters> element), not the whole document —
      // unlike sections/collection.liquid, `.pagination` here lives
      // OUTSIDE this element (it paginates the whole search page, not just
      // the products area), so this listens on the document instead.
      this.clickHandler = (event) => {
        const link = event.target.closest('.pagination a, .collection-filters__clear');
        if (!link) return;
        event.preventDefault();
        this.update(link.href);
      };
      document.addEventListener('click', this.clickHandler);

      this.popstateHandler = () => this.update(window.location.href, false);
      window.addEventListener('popstate', this.popstateHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.clickHandler);
      window.removeEventListener('popstate', this.popstateHandler);
      this.mobileQuery.removeEventListener('change', this.mobileQueryHandler);
    }

    syncSortControls() {
      const isMobile = this.mobileQuery.matches;
      this.querySelectorAll('[data-sort-select]').forEach((select) => {
        select.disabled = isMobile;
      });
      this.querySelectorAll('input[type="radio"][name="sort_by"]').forEach((radio) => {
        radio.disabled = !isMobile;
      });
    }

    togglePanel() {
      const isOpen = this.classList.toggle('is-filters-open');
      this.toggle.setAttribute('aria-expanded', String(isOpen));
    }

    // Serializes every named field in the filter form (the hidden `q`
    // field, checked checkboxes, price inputs, the sort select) into a
    // fresh query string. Deliberately NOT merged with the current URL's
    // existing query string, same reasoning as sections/collection.liquid's
    // `buildUrl()` — this resets pagination to page 1 on every filter/sort
    // change, and the form's own hidden `q` field is what keeps the search
    // term itself from being lost in that reset.
    buildUrl() {
      const params = new URLSearchParams(new FormData(this.form));
      Array.from(params.keys()).forEach((key) => {
        if (params.get(key) === '') params.delete(key);
      });
      const query = params.toString();
      return `${window.location.pathname}${query ? '?' + query : ''}`;
    }

    async update(url, pushState = true) {
      const target = url || this.buildUrl();
      const sectionUrl = `${target}${target.includes('?') ? '&' : '?'}section_id=${this.sectionId}`;

      const wasOpen = this.classList.contains('is-filters-open');
      const openGroups = Array.from(
        this.querySelectorAll('[data-accordion-toggle][aria-expanded="true"]')
      ).map((toggle) => toggle.getAttribute('aria-controls'));

      this.setAttribute('aria-busy', 'true');

      let html;
      try {
        const response = await fetch(sectionUrl);
        if (!response.ok) throw new Error(`Section request failed: ${response.status}`);
        html = await response.text();
      } catch (error) {
        this.removeAttribute('aria-busy');
        return;
      }

      const wrapper = document.getElementById(`shopify-section-${this.sectionId}`);
      if (!wrapper) return;
      wrapper.outerHTML = html;

      const fresh = document.getElementById(`shopify-section-${this.sectionId}`)?.querySelector('search-filters');
      if (fresh) {
        if (wasOpen) {
          fresh.classList.add('is-filters-open');
          fresh.querySelector('[data-filter-toggle]')?.setAttribute('aria-expanded', 'true');
        }
        openGroups.forEach((id) => {
          fresh.querySelector(`[aria-controls="${id}"]`)?.setAttribute('aria-expanded', 'true');
        });
      }

      if (pushState) {
        window.history.pushState({ searchFilters: true }, '', target);
      }
    }
  }

  customElements.define('search-filters', SearchFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-us"] && !Shopify.designMode) return;
  try {
    
  // Solution-card width equalizer — a section-specific layout concern,
  // deliberately separate from assets/carousel.js's `<theme-carousel>`
  // (that component only owns scrolling; this owns nothing about
  // scrolling at all, just the width of the solution cards it wraps).
  // See .why-us-card--solution's stylesheet comment for the CSS half of
  // this — that rule intentionally leaves a solution card's width
  // unconstrained so this script can measure its true intrinsic (nowrap)
  // width and equalize it against its siblings.
  //
  // Behavior: every `.why-us-card--solution` is measured at its natural
  // content width, then ALL of them are set to the LARGEST one measured
  // — so they line up with each other — capped so that shared width never
  // exceeds the fixed-width criteria card's own width (the criteria card
  // stays the widest card in the row by design). If this script never
  // loads, every solution card just falls back to its own intrinsic
  // width — narrower or wider than its siblings, but never wrapped.
  class WhyUsCards extends HTMLElement {
    connectedCallback() {
      this._equalize = this._equalize.bind(this);
      this._equalizeRows = this._equalizeRows.bind(this);

      this._mq = window.matchMedia('(max-width: 749px)');
      if (this._mq.addEventListener) {
        this._mq.addEventListener('change', this._equalize);
      } else if (this._mq.addListener) {
        // Safari <14 fallback — matchMedia predates addEventListener support.
        this._mq.addListener(this._equalize);
      }

      // Re-measure once webfonts finish loading — a heading measured
      // against a fallback font (before Petrona swaps in) can render at a
      // different width than its final one, throwing the equalized width
      // off until the next resize. `document.fonts` isn't supported in
      // every browser; measuring against the fallback font in that case
      // is an accepted trade-off, not worth a polyfill for.
      if (window.document.fonts && window.document.fonts.ready) {
        window.document.fonts.ready.then(this._equalize);
      }

      this._equalize();
    }

    // Row-height equalizer — this is what actually keeps a solution card's
    // yes/no icon on row N lined up with the criteria card's row N. Each
    // card's `.why-us-card__list` is its own independent flex column, so
    // nothing inherently ties "row 3 in this card" to "row 3 in that
    // card": a row's height is normally just tall enough for its OWN
    // content. That's fine until the criteria card's item text wraps onto
    // two lines (variable-length merchant copy, any row can wrap) while
    // the matching row in every solution card is just a single icon that
    // never wraps — that row stays at the CSS `min-height: 36px` while the
    // criteria row grows past it, so every row below the wrap point drifts
    // out of alignment across the cards. Fix: measure every row at each
    // index across ALL cards (criteria + every solution card), take the
    // tallest one measured, then force every card's row at that index to
    // that height — same "measure everyone, sync to the max" approach
    // `_equalize()` above already uses for solution-card widths, just
    // applied per-row instead of per-card. This is what keeps row N
    // positioned identically in every card regardless of which card's
    // text happens to wrap.
    _equalizeRows() {
      const cards = Array.from(this.querySelectorAll('.why-us-card'));
      if (!cards.length) return;

      const rowLists = cards.map((card) =>
        Array.from(card.querySelectorAll(':scope > .why-us-card__list > .why-us-card__row'))
      );

      // Reset to natural (CSS min-height-only) height before measuring —
      // otherwise a height forced by a PREVIOUS pass would taint this
      // pass's measurement instead of a fresh natural-content one.
      rowLists.forEach((rows) => rows.forEach((row) => { row.style.height = ''; }));

      const rowCount = rowLists.reduce((max, rows) => Math.max(max, rows.length), 0);

      for (let i = 0; i < rowCount; i++) {
        let maxHeight = 0;
        rowLists.forEach((rows) => {
          if (rows[i]) maxHeight = Math.max(maxHeight, rows[i].getBoundingClientRect().height);
        });
        rowLists.forEach((rows) => {
          if (rows[i]) rows[i].style.height = `${maxHeight}px`;
        });
      }
    }

    disconnectedCallback() {
      if (!this._mq) return;
      if (this._mq.removeEventListener) {
        this._mq.removeEventListener('change', this._equalize);
      } else if (this._mq.removeListener) {
        this._mq.removeListener(this._equalize);
      }
    }

    _equalize() {
      const criteria = this.querySelector('.why-us-card--criteria');
      const solutions = Array.from(this.querySelectorAll('.why-us-card--solution'));
      if (!solutions.length) return;

      // Reset to intrinsic width before measuring — otherwise a width
      // forced by a PREVIOUS pass (e.g. before a resize made the criteria
      // card, and therefore the cap, narrower) would taint this pass's
      // measurement instead of a fresh natural-content measurement.
      solutions.forEach((card) => { card.style.width = ''; });

      let maxWidth = 0;
      solutions.forEach((card) => {
        maxWidth = Math.max(maxWidth, card.getBoundingClientRect().width);
      });

      // The criteria card is the one card allowed a fixed width larger
      // than any solution card needs to be — cap the shared solution
      // width there so a solution card is never the widest card in the
      // row (a developer request).
      if (criteria) {
        maxWidth = Math.min(maxWidth, criteria.getBoundingClientRect().width);
      }

      solutions.forEach((card) => {
        card.style.width = `${maxWidth}px`;
      });

      // Row heights depend on final card width (width changes what wraps),
      // so this must run after the width pass above settles, every time —
      // not just once at load.
      this._equalizeRows();
    }
  }

  customElements.define('why-us-cards', WhyUsCards);

  } catch(e) { console.error(e); }
})();
})();
